import React from "react";
import { useSelector, useDispatch } from "react-redux";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/attritionAndCancelReasonsSaga";

const ViewFilter = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.attritionAndCancelReasons.moduleView);
  const selectedView = useSelector(
    (state) => state.attritionAndCancelReasons.selectedFilters.moduleView
  );

  return (
    <MultiSelectDropdown
      options={options}
      selectedFilters={selectedView}
      placeholder="Select View"
      numberDisplayed={0}
      multiple={false}
      keepOpen={false}
      includeFilter={false}
      onSelectChange={(data) => {
        if (data.id === selectedView.id) return;
        dispatch(actionCreators.updateModuleView(data));
      }}
    />
  );
};

export default ViewFilter;
